import privilegeApi from 'session-plugin/lib/utils/webapi/privilege'
import rolesTable from '@/meta/rolesTable'

const capitalize = (value) => value.charAt(0).toUpperCase() + value.slice(1)

export const state = {
  ...rolesTable.entries.reduce((prev, entry) => {
    prev[`can${capitalize(entry.value)}`] = false
    return prev
  }, {})
}

export const mutations = {
  setPrivileges (state, payload) {
    payload.forEach((feature) => {
      rolesTable.entries.forEach((i) => {
        if (i.value === feature.value) {
          state[`can${capitalize(feature.value)}`] = feature.available
        }
      })
    })
  }
}

export const getters = {
  getPrivileges: state => (privileges) => {
    return privileges.reduce((prev, privilege) => {
      prev[privilege] = state[privilege]
      return prev
    }, {})
  },
  getPrivilege: state => (privilege) => {
    return state[privilege]
  },
}

export const actions = {
  async initPrivileges ({ state, commit }) {
    const res = await privilegeApi.session()
    commit('setPrivileges', (await res.json()).features)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
